import { i18n, inject, React } from "aaa";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { ErrorScreen, Props as ErrorScreenProps } from "./ErrorScreen";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
}

@i18n.injectIntl
@inject("externalInterfaceStore")
export default class Component extends React.Component<IProps & i18n.InjectedIntlProps & ErrorScreenProps, {}> {
    render() {
        const { intl, externalInterfaceStore, ...errorScreenProps } = this.props;
        const __ = i18n.bindStr(intl);
        return (
            <ErrorScreen
                externalInterfaceStore={externalInterfaceStore}
                title={__("error.unauthorized.title")}
                exitError="unauthorized"
                hideButton
                {...errorScreenProps}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Unauthorized.tsx